(function() {

    /**
     * @type BasketButtons
     */
    var BasketButtons = (/** @constructor */ function () {

        /** @type {Object} параметры */
        var opt = {
            slideOutDuration : 350
        };

        var objectHash = {},
            $buttons,
            $dbuttons;

        /**
         * Обработка нажатия
         * @private
         */
        function clickOneHandler(e) {
            e.preventDefault();
            var $t = $(this);
            if (!$t.hasClass('load')) {
                    var can_add = true;
					var params = { prod_type: $t.data('productType') };
                    var id = $t.data('productId');
                    var $button = objectHash[id];
                    if($button){
                        var count = $button.attr('data-count');
                        //var count = $button.parents('tr').find('.count input').val();
						            //if (count > 0) { can_add = false; }
                    }
                    //count = 1;
                    if(can_add){
                        $.fancybox.showLoading();
                        $t.addClass('load');
                        Order.add(id, count, oneResponseHandler, params);
                    }
            }
        }


        function clickAddHandler(e) {
            e.preventDefault();
            var $t = $(this);
            if (!$t.hasClass('load')) {
                    var can_add = true;
					var params = { prod_type: $t.data('productType') };
                    var id = $t.data('productId');
                    var $button = objectHash[id];
                    if($button){
                        var count = $button.attr('data-count');
                        //var count = $button.parents('tr').find('.count input').val();
						            //if (count > 0) { can_add = false; }
                    }
                    //count = 1;
                    if(can_add){
                        $.fancybox.showLoading();
                        $t.addClass('load');
                        Order.add(id, count, addResponseHandler, params);
                    }
            }
        }

        /**
         * Обработка ответа сервера о добавлении
         * @param {Object} data данные
         * @private
         */
        function addResponseHandler(data) {
            $.fancybox.hideLoading();
            $buttons.removeClass('load');
            if ((data) && (data.item)) {
                var $button = objectHash[data.item.id];
                if ($button) {
					          if (data.item.count>0) {
						            $button.addClass('hidden').siblings('.btn-del').removeClass('hidden');
                        $button.parents('tr').addClass('active');
						            $button.attr('data-count', data.item.count);
                        dataLayer.push({
                            "ecommerce": {
                                "add": {
                                    "products": [
                                        {
                                            "id": data.item.id,
                                            "name": data.item.name,
                                            "price": data.item.price,
                                            "quantity": data.item.count
                                        }
                                    ]
                                }
                            }
                        });
					          }
                }
            }
        }

        function oneResponseHandler(data) {
            $.fancybox.hideLoading();
            $cbuttons.removeClass('load');
            if ((data) && (data.item)) {
                var $button = objectHash[data.item.id];
                if ($button) {
          					if (data.item.count>0) {
            						$button.attr('data-count', data.item.count);
                        $('#modal').modal('show');
                        dataLayer.push({
                            "ecommerce": {
                                "add": {
                                    "products": [
                                        {
                                            "id": data.item.id,
                                            "name": data.item.name,
                                            "price": data.item.price,
                                            "quantity": data.item.count
                                        }
                                    ]
                                }
                            }
                        });
        					  }
                }
            }
        }

        function clickDelHandler(e) {
            e.preventDefault();
                id = $(this).data('productId');
                $.fancybox.showLoading();
                Order.update(id, 0, delResponseHandler);
        }

        function delResponseHandler(data) {
            $.fancybox.hideLoading();
            if ((data) && (data.deleted)) {
                var $button = objectHash[data.deleted].siblings('.btn-del');
                if ($button) {
                    $button.addClass('hidden').siblings('.btn-buy').removeClass('hidden');
                    $button.parents('tr').removeClass('active');
                    objectHash[data.deleted].parents('tr').find('.count input').val(1);
                    $button.siblings('.btn-buy').attr('data-count', 1);
                    dataLayer.push({
                        "ecommerce": {
                            "remove": {
                                "products": [
                                    {
                                        "id": data.deleted,
                                    }
                                ]
                            }
                        }
                    });
                }
            }
        }

        function countChangeHandler() {
            var id = $(this).parents('td').data('productId'),
            count = this.value,
            $button = objectHash[id];
            $button.attr('data-count',count);
            console.log($button, $button.hasClass('hidden'));
            if ($button && $button.hasClass('hidden')) {
                Order.update(id, count, updateResponseHandler);
            }
        }

        function updateResponseHandler(data) {
            $.fancybox.hideLoading();
            if ((data) && (data.item)) {
                var $button = objectHash[data.item];
                return;
                if ($button) {
                    $button.addClass('hidden').siblings('.btn-buy').removeClass('hidden');
                    $button.parents('tr').removeClass('active');
                    $button.siblings('.btn-buy').attr('data-count', 0);
                }
            }
        }

        return {
            /**
             * Инициализация
             * @memberOf BasketButtons
             * @param {Object} [options] параметры
             */
            init : function(options) {
                $.extend(opt, options);
                $buttons = $(opt.selector);
                $buttons.click(clickAddHandler);
                $dbuttons = $('.btn-del');
                $dbuttons.click(clickDelHandler);
                $cbuttons = $('.btn-click');
                $cbuttons.click(clickOneHandler);
                for (var i = 0; i < $buttons.length; i++) {
                    var id = $buttons.eq(i).data('productId');

                    objectHash[id] = $buttons.eq(i);

                    var inp = objectHash[id].parents('tr').find(".count input");
                    if(inp.length>0){
                        inp.inputArrowCounter().change(countChangeHandler);
                        objectHash[id].data("inp", inp);
                    }

                }
            }
        };

    })();

    Order.BasketButtons = BasketButtons;
})();